import React from "react";
import ContactDetails from "../ContactDetails";

import { aireLogo, hsfLogo } from "../../utils/images";

const Intro1 = ({ prefix, language }) => {
  const text = getText(language);
  return (
    <div>
      <img src={aireLogo} alt="AIRE Logo" className="introLogo" />
      <img src={hsfLogo} alt="HSF Logo" className="introLogo" />
      <div className="languageList">
        <a href={`/${prefix}/`}>English</a>
        <a href={`/${prefix}/bg`}>български</a>
        <a href={`/${prefix}/it`}>Italiano</a>
        <a href={`/${prefix}/ru`}>русский</a>
        <a href={`/${prefix}/es`}>Español</a>
        <a href={`/${prefix}/hi`}>हिन्दी</a>
      </div>
      {text}
      <ContactDetails language={language} appName="Permanent Residence" />
    </div>
  );
};

const getText = (language) => {
  switch (language) {
    case "en":
      return (
        <>
          <p>
            If you are in a vulnerable situation or have been a victim of
            domestic abuse, please contact us directly by phone or email at the
            contact details below for advice, <strong>before</strong> using this
            app.
          </p>
          <p>
            This app should only be used by individuals or for clients who are
            currently residing in the UK or who have lived in the UK for a
            period of time. It has not been designed to be used by individuals
            or for clients who are considering relocating to the UK.
          </p>
        </>
      );
    case "bg":
      return (
        <>
          <p>
            Ако сте в ситуация на уязвимост или сте били жертва на домашно
            насилие, моля преди да използвате апликацията, свържете се с нас
            директно на телефонния номер или имейл по-долу за съвет.
          </p>
          <p>
            Тази апликация е само за хора или клиенти, които пребивават в
            момента в Обединеното Кралство или са живели в Обединеното Кралство
            за период от време. Апликацията не е подходяща за хора или клиенти,
            които смятат тепърва да се преместят в Обединеното Кралство.
          </p>
        </>
      );
    case "it":
      return (
        <>
          <p>
            Se ti trovi in uno stato di vulnerabilità o sei stata vittima di
            abusi domestici, per favore contattaci direttamente via telefono o
            via e-mail ai contatti che seguono per consigli, prima di utilizzare
            questa applicazione.
          </p>
          <p>
            Questa applicazione deve essere utilizzata solo da individui o per
            clienti che risiedono attualmente in GB o hanno vissuto in GB per un
            periodo di tempo. Non è stata creata per l'utilizzo da parte di
            individui o per clienti che stanno considerando di riposizionarsi in
            GB.
          </p>
        </>
      );
    case "ru":
      return (
        <>
          <p>
            Если вы находитесь в уязвимой ситуации или стали жертвой домашнего
            насилия, пожалуйста, свяжитесь с нами напрямую по телефону или
            электронной почте по указанным ниже контактным данным для получения
            совета перед использованием этого приложения.
          </p>
          <p>
            Это приложение должно использоваться только лицами или клиентами,
            которые в настоящее время проживают в Великобритании или которые
            проживали в Великобритании в течение определенного периода времени.
            Это приложение не предназначено для использования лицами или
            клиентами, которые рассматривают возможность переезда в
            Великобританию.
          </p>
        </>
      );
    case "es":
      return (
        <>
          <p>
            Si usted esta en una situación de vulnerabilidad o ha sido víctima
            de violencia de género, por favor contacte directamente con nosotros
            por teléfono o email con los datos de contacto que figuran a
            continuación para obtener asesoramiento, antes de utilizar esta
            aplicación.
          </p>
          <p>
            Esta aplicación sólo debe ser utilizada por personas o clientes que
            residan actualmente en el Reino Unido o que hayan vivido en el Reino
            Unido durante un período de tiempo. No ha sido diseñada para ser
            utilizada por personas o clientes que estén considerando mudarse al
            Reino Unido.
          </p>
        </>
      );
    case "hi":
      return (
        <>
          <p>
            यदि आप कमजोर स्थिति में हैं या घरेलू दुर्व्यवहार का शिकार हो चुके
            हैं, तो कृपया इस ऐप का उपयोग करने से पहले, सलाह के लिए नीचे दिए गए
            संपर्क विवरण पर फोन या ईमेल द्वारा हमसे सीधे संपर्क करें।
          </p>
          <p>
            इस ऐप का उपयोग केवल उन व्यक्तियों या ग्राहकों के लिए किया जाना चाहिए
            जो वर्तमान में यूके में रहते हैं या रह चुके हैं। यूके में
            स्थानांतरित करने पर विचार करने वाले ग्राहकों के लिए उपयोग करने के
            लिए डिज़ाइन नहीं है।
          </p>
        </>
      );

    default:
      break;
  }
};

export default Intro1;
